import React from 'react'
import '../../graphStyles.scss'

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
  import { Bar } from 'react-chartjs-2'
  
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  )




/**
 * Made up data to be replaced
 */
const labels = [
    'Age (25-44)',
    'Gender (Male)',
    'State (CA, NY)',
    'Device (Andriod)',
    'Day of Week (Sat)',
    'Time of Day (evening)',
    'Word Group 1 (Environmentall Friendly)',
    'Word Group 2 (Traditional Razor)',
    'Word Group 3 (Platinum Coated)',
    'Word Group 4 (Super Saver Pack)'
]

const fakeClicks = [
    [10], 
    [null, 18], 
    [null, null, 25], 
    [null, null, null, 35], 
    [null, null, null, null, 40],
    [null, null, null, null, null, 50], 
    [null, null, null, null, null, null, 58], 
    [null, null, null, null, null, null, null, 62], 
    [null, null, null, null, null, null, null, null, 70], 
    [null, null, null, null, null, null, null, null, null, 75]
]






export function TopFeaturesClicksGraph({ features, clicks }) {

  // Uncomment and delete above labels array
  //const labels = features


  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
            // Only displays first label because of space at the end of the string
            filter: (l) => (l.text === 'Clicks ')
        },
        onHover: function (event, legendItem) {
          document.getElementById("chart11").style.cursor = 'pointer'
        },
        onLeave: function (event, legendItem) {
          document.getElementById("chart11").style.cursor = 'default'
        },
      },

    },
    scales: {
        x: {
        
            title: {
                display: true,
                text: 'List of Features',
                font: {
                    size: 13.5
                }
            },
            grid: {
                display: false
            },
            stacked: true
            
        },
        y: {
            title: {
              display: true,
              text: 'Number of Clicks',
              font: {
                size: 13.5
              }
            }
        },   
    },
  }



  const data = {

    // Replace with weeks prop
    labels,

    datasets: [
      {
        label: 'Clicks ',

        // Replace with clicks prop
        // Light blue
        data: fakeClicks[0],
        backgroundColor: 'rgba(0, 200, 248)',
      },
      {
        label: 'Clicks',
        // Red
        data: fakeClicks[1],
        backgroundColor: 'rgba(200, 35, 60)',
      },
      {
        label: 'Clicks',

        // Yellow
        data: fakeClicks[2],
        backgroundColor: 'rgba(250, 196, 60)',
      },
      {
        label: 'Clicks',

        // Teal
        data: fakeClicks[3],
        backgroundColor: 'rgba(13, 155, 98)',
      },
      {
        label: 'Clicks',

        // Orange
        data: fakeClicks[4],
        backgroundColor: 'rgba(209, 150, 98)',
      },
      {
        label: 'Clicks',

        // Dark Blue
        data: fakeClicks[5],
        backgroundColor: 'rgba(32, 43, 165, 1)'
      },
      {
        label: 'Clicks',

        // Pink
        data: fakeClicks[6],
        backgroundColor: 'rgba(255, 188, 207, 1)'
      },
      {
        label: 'Clicks',

        // Blue
        data: fakeClicks[7],
        backgroundColor: 'rgba(150, 136, 255, 1)'
      },
      {
        label: 'Clicks',

        // Green
        data: fakeClicks[8],
        backgroundColor: 'rgba(88, 204, 108, 1)'
      },
      {
        label: 'Clicks',

        // Purple
        data: fakeClicks[9],
        backgroundColor: 'rgba(175, 100, 184, 1)'
      },
      
    ],
  }



    return (
        <div className='graph'>
            <div className='graph__title'>
                <h4>Top Important Features Based On Clicks</h4>
            </div>
            <Bar className='chart' id='chart11' options={options} data={data}/>
        </div>
    )
}
